export const getCardQuery = /* GraphQL */ `
    query {
        getCard {
            status
            cardType
            installments
            cardNumber
            cardBrand
        }
    }
`

export interface GetCardOutput {
    getCard: {
        status: boolean
        cardType: string
        installments: string
        cardNumber: string | null
        cardBrand: string
    }
}
